/* ─────────────────────────────────────────────────────────
   Fitcooker — Global JavaScript
   Scroll animations · Header · FAQ · Stock · Tabs
───────────────────────────────────────────────────────── */

(function () {
  'use strict';

  /* ── Intersection Observer: scroll animations ─────────── */
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  function observeAnimations() {
    document
      .querySelectorAll('.anim-fade-up, .anim-fade-in, .anim-scale-in, .bowl-reveal')
      .forEach((el) => observer.observe(el));
  }

  /* ── Header scroll behaviour ──────────────────────────── */
  function initHeader() {
    const header = document.querySelector('.shopify-section-group-header-group');
    if (!header) return;
    const onScroll = () => header.classList.toggle('fc-scrolled', window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Stock counter animation ──────────────────────────── */
  function animateCount(el, target, duration) {
    duration = duration || 1200;
    const start = performance.now();
    const update = (time) => {
      const progress = Math.min((time - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(eased * target);
      if (progress < 1) requestAnimationFrame(update);
    };
    requestAnimationFrame(update);
  }

  function initStockCounters() {
    document.querySelectorAll('.stock-count[data-target]').forEach((el) => {
      const target = parseInt(el.dataset.target, 10) || 0;
      el.textContent = '0';
      const obs = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          animateCount(el, target);
          obs.unobserve(el);
        }
      }, { threshold: 0.5 });
      obs.observe(el);
    });

    document.querySelectorAll('.stock-bar-fill[data-remaining]').forEach((el) => {
      const remaining = parseInt(el.dataset.remaining, 10) || 0;
      const total = parseInt(el.dataset.total, 10) || 400;
      const pct = Math.min(Math.round((remaining / total) * 100), 100);
      el.style.setProperty('--bar-width', pct + '%');
      const obs = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setTimeout(() => el.classList.add('animate'), 100);
          obs.unobserve(el);
        }
      }, { threshold: 0.5 });
      obs.observe(el);
    });
  }

  /* ── FAQ accordion ────────────────────────────────────── */
  function initFAQ() {
    document.querySelectorAll('.fc-faq-row').forEach((row) => {
      row.addEventListener('click', () => {
        const isOpen = row.classList.contains('open');
        document.querySelectorAll('.fc-faq-row.open').forEach((r) => r.classList.remove('open'));
        if (!isOpen) row.classList.add('open');
      });
    });
  }

  /* ── Meal tab selector (Block 7) ──────────────────────── */
  function initMealTabs() {
    document.querySelectorAll('.fc-meal-tabs').forEach((tabs) => {
      const buttons = tabs.querySelectorAll('.fc-tab-btn');
      const panels = tabs.closest('.fc-two-bowls')
        ? tabs.closest('.fc-two-bowls').querySelectorAll('.fc-tab-panel')
        : tabs.parentElement.querySelectorAll('.fc-tab-panel');

      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          buttons.forEach((b) => b.classList.remove('active'));
          panels.forEach((p) => p.classList.remove('active'));
          btn.classList.add('active');
          const target = btn.dataset.tab;
          const panel = Array.from(panels).find((p) => p.dataset.tab === target);
          if (panel) panel.classList.add('active');
        });
      });
    });
  }

  /* ── Programs expand/collapse (Block 10) ─────────────── */
  function initProgramsToggle() {
    document.querySelectorAll('.fc-programs-toggle').forEach((btn) => {
      btn.addEventListener('click', () => {
        const grid = btn.closest('.fc-programs-wrap');
        if (!grid) return;
        grid.querySelectorAll('.fc-card-hidden').forEach((card) => {
          card.classList.toggle('fc-card-visible');
        });
        btn.textContent = btn.textContent.includes('See all')
          ? 'Show less ↑'
          : 'See all programs ↓';
      });
    });
  }

  /* ── Init all ─────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    observeAnimations();
    initHeader();
    initStockCounters();
    initFAQ();
    initMealTabs();
    initProgramsToggle();
  });
})();
